export function zeroBasedLineToMonaco(line: number): number {
    return line + 1
}
